module.exports = __webpack_public_path__ + "static/media/t-wew.305e277e.svg";